<template>
  <div v-if="!forceDanish">
    <div class="flex items-center space-x-1 text-sm">
      <button @click="() => switchLanguage('da')" :class="{ 'font-bold underline': locale === 'da' }"
        class="hover:text-gray-300">
        Da
      </button>
      <span>/</span>
      <button @click="() => switchLanguage('en')" :class="{ 'font-bold underline': locale === 'en' }"
        class="hover:text-gray-300">
        En
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useLogger } from '~/composables/useLogger'
import { useConfigStore } from '~/stores/useConfigStore'
import { storeToRefs } from 'pinia'

const { locale } = useI18n()
const { $setLanguage } = useNuxtApp()
const configStore = useConfigStore()
const { userConfiguration } = storeToRefs(configStore)

// Default to not forcing Danish
const forceDanish = ref(false)

const logger = useLogger()

/**
 * Switches the application language
 * Uses the setLanguage function provided by i18n-init plugin
 */
async function switchLanguage(lang: string) {
  logger.debug(`LanguageSwitcher: Switching language to ${lang}`)
  
  try {
    // Note: $setLanguage now handles storing in both preferences and customer config
    const success = await $setLanguage(lang)
    if (!success) {
      logger.error(`LanguageSwitcher: Failed to switch language to ${lang}`)
    }
  } catch (error) {
    logger.logErrorCaught('Error switching language', 'LanguageSwitcher.vue', error)
    useToast().add({
      title: 'Error',
      description: 'Failed to switch language',
      color: 'red',
    })
  }
}

// If forceDanish is true, switch to Danish on component mount
onMounted(() => {
  if (forceDanish.value) {
    logger.debug('LanguageSwitcher: Force Danish mode active')
    switchLanguage('da')
  }
})
</script>
